import { baseApi } from "@/Redux/api/baseApi";

const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCategory: builder.query({
      query: () => ({
        url: "/public/category/view",
        method: "GET",
      }),
    }),

    getSingleCategory: builder.query({
      query: (id) => ({
        url: `/public/podcast/category/podcast/${id}`,
        method: "GET",
      }),
    }),

    getTopCategory: builder.query({
      query: () => ({
        url: `/public/category/top`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllCategoryQuery,
  useGetSingleCategoryQuery,
  useGetTopCategoryQuery,
} = categoryApi;
